export default "__VITE_ASSET__838e835a__"